// §11.14 / §9.1 — Alarms & Stopwatch as an in-process app.
//
// **Ungated**, unlike the social apps: a stopwatch is a stopwatch whether or not anybody is signed
// in, and a guest's schedule persists to their own browser exactly as their files do (§7.6).
//
// Not lazy. The schedule already runs in the kernel whether this window is open or not, so the
// only thing a lazy chunk would defer is the drawing — and the window a §13 alarm toast sends
// somebody to is the one place a chunk fetch would be felt.
import type { AlarmShellAccess, InProcessApp } from '@hangar/shared';
import { createRoot, type Root } from 'react-dom/client';
import { Alarms } from './Alarms';

export function createAlarmsApp(access: AlarmShellAccess): InProcessApp {
  const roots = new WeakMap<HTMLElement, Root>();
  return {
    id: 'alarms',
    name: 'Alarms & Stopwatch',
    icon: { glyph: 'alarm-clock', hue: 6 },
    keywords: ['alarm', 'stopwatch', 'timer', 'clock', 'wake', 'lap', 'snooze'],
    window: { width: 560, height: 520, minWidth: 380, minHeight: 320, multiWindow: false },
    mount(container) {
      const root = createRoot(container);
      roots.set(container, root);
      root.render(<Alarms access={access} />);
    },
    unmount(container) {
      const root = roots.get(container);
      roots.delete(container);
      root?.unmount();
    },
  };
}
